export default {
  text: 'O mapa é fornecido pela Google. Ao carregá-lo, o seu endereço IP é enviado à Google.',
  buttons: {
    show_map: 'Mostrar mapa',
    retry: 'Tentar novamente',
  },
  errors: {
    map_unavailable: 'Não foi possível carregar o mapa.',
  },
};
